import { createChildListViewContainer } from 'factories/ChildListView'
import Component from 'components/CycleCounts/Details'

export default createChildListViewContainer()(Component)
